/**
 * Тип подключения/технологии строительства сети на конкретном адресе
 */
export const TECHNOLOGY_TYPE = {
  PON: { typeId: 1, hours: 5 },
  DRS: { typeId: 0, hours: 1 },
};
